import React from 'react';
import {
  Box,
  SimpleGrid,
  VStack,
  HStack,
  Text,
  Badge,
  Progress,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorModeValue,
  Avatar,
  Tooltip,
  CircularProgress,
  CircularProgressLabel,
  Tag,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Icon,
} from '@chakra-ui/react';
import {
  Brain,
  GitBranch,
  Activity,
  BarChart2,
  MoreVertical,
  Eye,
  Play,
  Pause,
  RefreshCw,
  Download,
  FileText,
  Settings,
  AlertTriangle,
  CheckCircle,
  Clock,
  Database,
  Zap,
  Lightbulb,
  MessageSquare,
  Users,
} from 'lucide-react';
import { MethodistSlide } from '../../components/base/MethodistSlide';
import { NexusAdminLayout } from '../../components/nexus/NexusAdminLayout';
import DashboardPanel from '../ui-samples/crowdsourcing/DashboardPanel';
import IdeaManagementPanel from '../ui-samples/crowdsourcing/IdeaManagementPanel';
import WorkflowPanel from '../ui-samples/crowdsourcing/WorkflowPanel';
import AnalyticsPanel from '../ui-samples/crowdsourcing/AnalyticsPanel';
import ContentPanel from '../ui-samples/crowdsourcing/ContentPanel';
import AdminToolsPanel from '../ui-samples/crowdsourcing/AdminToolsPanel';

// Sample data for crowdsourcing metrics
const metrics = [
  {
    label: "Active Ideas",
    value: "124",
    change: "+12",
    icon: Lightbulb,
    color: "methodist.purple",
  },
  {
    label: "Engagement Rate",
    value: "87.5%",
    change: "+5.2%",
    icon: Activity,
    color: "methodist.blue",
  },
  {
    label: "Implementation Rate",
    value: "42.3%",
    change: "+3.8%",
    icon: CheckCircle,
    color: "methodist.green",
  },
];

const activeIdeas = [
  {
    id: "IDEA-001",
    title: "AI-Assisted Patient Scheduling",
    category: "Practice Efficiency",
    status: "under_review",
    votes: 156,
    impact: "high",
    submittedBy: "Dr. Emily Chen",
    department: "Internal Medicine",
    submittedDate: "2d ago",
  },
  {
    id: "IDEA-002",
    title: "Wellness Check-in Automation",
    category: "Culture of Wellness",
    status: "implementing",
    votes: 142,
    impact: "medium",
    submittedBy: "Dr. James Wilson",
    department: "Psychiatry",
    submittedDate: "5d ago",
  },
  {
    id: "IDEA-003",
    title: "Clinical Decision Support Enhancement",
    category: "Practice Efficiency",
    status: "approved",
    votes: 198,
    impact: "high",
    submittedBy: "Dr. Sarah Martinez",
    department: "Emergency Medicine",
    submittedDate: "1w ago",
  },
];

const CrowdsourcingSlide: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.300');
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <MethodistSlide title="Nexus">
      <NexusAdminLayout
        title="Nexus: Crowdsourcing Hub"
        activeSection="crowdsourcing"
        userName="Dr. Sarah Chen"
        userRole="Clinical Innovation Lead"
      >
        <Tabs variant="enclosed" colorScheme="purple" onChange={(index) => setActiveTab(index)} defaultIndex={0}>
          <TabList>
            <Tab><HStack><Icon as={Database} boxSize={4} /><Text>Overview</Text></HStack></Tab>
            <Tab><HStack><Icon as={Brain} boxSize={4} /><Text>AI Analysis</Text></HStack></Tab>
            <Tab><HStack><Icon as={GitBranch} boxSize={4} /><Text>Governance</Text></HStack></Tab>
            <Tab><HStack><Icon as={BarChart2} boxSize={4} /><Text>Impact</Text></HStack></Tab>
            <Tab><HStack><Icon as={Zap} boxSize={4} /><Text>Implementation</Text></HStack></Tab>
          </TabList>
          
          <TabPanels>
            {/* Overview Panel */}
            <TabPanel p={0} pt={4}>
              <DashboardPanel />
            </TabPanel>
            
            {/* AI Analysis Panel */}
            <TabPanel p={0} pt={4}>
              <IdeaManagementPanel />
            </TabPanel>
            
            {/* Governance Panel */}
            <TabPanel p={0} pt={4}>
              <WorkflowPanel />
            </TabPanel>
            
            {/* Impact Panel */}
            <TabPanel p={0} pt={4}>
              <AnalyticsPanel />
            </TabPanel>
            
            {/* Implementation Panel */}
            <TabPanel p={0} pt={4}>
              <ContentPanel />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </NexusAdminLayout>
    </MethodistSlide>
  );
};

export default CrowdsourcingSlide;
